import { useContext, useState } from 'react';
import { useEffect } from 'react';
import { createContext } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { apiJalles } from '../services/api';
import { HomeContext } from './contexHome';

export const AdminContext = createContext({});

export const AdminProvider = () => {
  const navigate = useNavigate();

  const { user } = useContext(HomeContext);

  const [loading, setLoading] = useState(false);
  const [adminPage, setAdminPage] = useState('User');
  const [usersSave, setUsersSave] = useState([]);
  const [modalUserDeletConfirmation, setModalUserDeletConfirmation] = useState(false);
  const [modalEditUser, setModalEditUser] = useState(false);
  const [modalBTGtw, setModalBTGtw] = useState(false);
  const [modaUpdatePassword, setModalUpdatePassword] = useState(false);
  const [modalCreatingUser, setModalCreatingUser] = useState(false);
  const [salveUserId, setSaveUserId] = useState(0);
  const [saveUserGtw, setSaveUserGtw] = useState(0);

  const [modalConfimation, setModalConfimation] = useState(false);
  const [salveTanqueInfo, setSalveTanqueInfo] = useState([]);
  const [modalBombaTanque, setModalBombaTaque] = useState(false);
  const [modalCreatTanque, setModalCreatTanque] = useState(false);

  const token = sessionStorage.getItem('connectionsToken');
  const headerApi = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const uservalidation = async () => {
    setLoading(true);
    try {
      const api = await apiJalles.get('/users/LeituraTodos', headerApi);
      setUsersSave(api.data);
    } catch (error) {
      toast.warn('😅Algo de Errado', {
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'light',
      });
    } finally {
      setLoading(false);
    }
  };

  const deleteUser = async (id) => {
    setLoading(true);
    try {
      const UserDelete = await apiJalles.delete(`/users/${id}`, headerApi);
      uservalidation();
      toast.success('Usuario Deletado com Sucesso', {
        position: 'top-right',
        autoClose: 1000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'dark',
      });
    } catch (error) {
      console.error(error);
      toast.warn('😅Algo de Errado', {
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'light',
      });
    } finally {
      setModalUserDeletConfirmation(!modalUserDeletConfirmation);
      setLoading(false);
    }
  };

  const handleUsertCreation = async (data) => {
    if (data.email === '') {
      data.email = null;
    }
    setLoading(true);
    try {
      const UserCreation = await apiJalles.post(`/users`, data, headerApi);
      uservalidation();
      toast.success('Novo usuario criado com sucesso', {
        position: 'top-right',
        autoClose: 1000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'dark',
      });
    } catch (error) {
      console.error(error);
      toast.warn('Falha Provavelmente UserName ou e-mail já Cadastrados.', {
        position: 'top-right',
        autoClose: 2500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'dark',
      });
    } finally {
      setModalCreatingUser(!modalCreatingUser);
      setLoading(false);
    }
  };

  const handleUserUpdate = async (data) => {
    setLoading(true);
    try {
      const user = await apiJalles.patch(`users/${salveUserId}/`, data, headerApi);
      const api = await apiJalles.get('users/LeituraTodos', headerApi);
      setUsersSave(api.data);
      toast.success('Alterações Salvas com sucesso', {
        position: 'top-right',
        autoClose: 1000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'dark',
      });
    } catch (error) {
      toast.warn('😅Algo de Errado', {
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'light',
      });
    } finally {
      setModalEditUser(false);
      setModalUpdatePassword(false);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (user.is_superuser === false) {
      navigate('/');
    } else {
      uservalidation();
    }
  }, []);

  return (
    <AdminContext.Provider
      value={{
        loading,
        adminPage,
        setAdminPage,
        usersSave,
        headerApi,
        modalCreatingUser,
        setModalCreatingUser,
        handleUsertCreation,
        modalUserDeletConfirmation,
        setModalUserDeletConfirmation,
        salveUserId,
        setSaveUserId,
        deleteUser,
        modaUpdatePassword,
        setModalUpdatePassword,
        handleUserUpdate,
        modalEditUser,
        setModalEditUser,
        modalBTGtw,
        setModalBTGtw,
        modalConfimation,
        setModalConfimation,
        salveTanqueInfo,
        setSalveTanqueInfo,
        modalBombaTanque,
        setModalBombaTaque,
        modalCreatTanque,
        setModalCreatTanque,
        saveUserGtw,
        setSaveUserGtw,
        uservalidation,
      }}
    >
      <Outlet />
    </AdminContext.Provider>
  );
};
